<script>
import { VAlert } from 'vuetify/lib';
export default VAlert;
</script>
